/* eslint-disable react/jsx-no-useless-fragment */
import React, {
  FC, Suspense, lazy, useState, useEffect,
  } from 'react';
import styled from 'styled-components';
// import { useHistory, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';
import { PageParams } from 'constants/interfaces/GlobalInterfaces';
// import { TAB_AUDIENCE } from 'constants/paths';
import AudienceContacts from 'modules/Audience/Page/AudienceContacts';
import AudienceLists from 'modules/Audience/Page/AudienceLists';
import AudienceListDetails from 'modules/Audience/Page/AudienceListDetails';
import classNames from 'classnames';
import SubNavbarSearchSkeleton from 'modules/Common/Skeleton/SubNavbarSearchSkeleton';
import { TAB_AUDIENCE } from 'constants/paths';
import {
  maxTablet, maxWidth, minHeight, retina,
} from 'constants/utilsStyles';
import DetailProfile from 'modules/Campaigns/Audience/People/DetailProfile';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { closeDetailProfile, closeOverlay } from 'modules/GlobalActions';
import { getQueryListId } from 'utils';
import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';
import CreateContactSidebar from '../../Campaigns/Audience/People/CreateContactSidebar';
import { closeEditContactSidePanelAction, resetCreateNewContactAction } from '../Actions/globalContanctsActions';
import { LIST_CONTACTS_UPDATE_CONTACT } from '../../../constants/types/audienceTypesNew';
import {
  resetAudienceList, resetAudienceSearchedList, resetScheduledEmailLists, setScheduledEmailModalOpen,
} from '../Actions/listsActions';
// import AudienceHeaderSticky from 'modules/Campaigns/Audience/Components/AudienceHeaderSticky';
// lazy load components
const AudienceStickyHeader = lazy(() => import('modules/Audience/Components/Header/AudienceStickyHeader'));
const AudienceSearchHeader = lazy(() => import('modules/Audience/Components/SearchHeaders/AudienceSearchHeader'));
// const ContactsFooterWrapper = lazy(() => import('modules/Audience/Components/Footer/ContactsFooter'));
const FloatingSidebarTwo = lazy(() => import('modules/Common/Components/FloatingSidebarTwo'));
const ExportPopupNew = lazy(() => import('modules/Audience/Components/Header/ExportPopupNew'));

interface WrapperProps {
  isGlobalContactsSelected?: boolean;
  isListSelected?: boolean;
}

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  #confirm-dialog {
    width: 312px !important;
  }
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
  .message {
    font-weight: 500 !important;
    font-size: 20px !important;
    font-family: 'Roboto Slab', serif !important;
    line-height: 20px !important;
  }
  #title-question {
    padding-top: 16px;
  }
`;

const Wrapper = styled.div<WrapperProps>`
  &.internalAudienceWrapper {
    overflow-y: hidden;
  }
  padding: 140px 90px 0 90px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 110px 65px 0 65px;
  }
  @media all and (max-width: ${maxTablet}) {
    padding: 105px 10px 0 10px;
  }
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-top: 110px;
  }
  @media all and (max-height: 781px) and (min-height: ${minHeight}) {
    padding-top: 130px;
  }
  .parent-container {
    &.indexAppend {
      position: relative;
      z-index: 12;
      .wrapper-footer {
        visibility: hidden;
        .right-side {
          .open {
            visibility: visible;
          }
        }
      }
    }

    .inner-container {
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;
      &.containerMoveUp {
        padding-bottom: 94px;
      }
      &.internalContainer {
        height: calc(100vh - 200px);
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: calc(100vh - 150px);
        }
      }
      .sub-container {
        height: 385px;
        @media all and (max-width: ${maxWidth}), ${retina} {
          height: 375px;
        }
        &.blockViewShow {
          height: 405px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: 350px;
          }
        }
        &.tableViewContainer {
          height: 490px;
          min-height: 420px;
          .heading-div {
            .view-switch-cmp {
              margin-right: 2px;
            }
          }
        }
        &.list-container {
          &.tileView {
            height: 405px;
            .heading-div {
              padding-right: 5px;
            }
            .aud-Infinite-scroll {
              padding-left: 10px;
            }
          }
          height: 410px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: 365px;
          }
        }
        .infinite-scroll-component__outerdiv {
          height: 110%;
          @media all and (max-width: ${maxWidth}), ${retina} {
            height: 105%;
          }
        }
      }
    }
  }
  .no-data-found {
    width: 100%;
  }
  .links {
    display: grid;
    color: white;
    margin-top: 8px;
  }
  .links a {
    color: #fff;
  }
`;

// interface IAudienceWrapper extends PageParams {
//   // screen?: string;
// }

const AudienceWrapper: FC<PageParams> = (props) => {
  const dispatch = useDispatch();
  const {
    page,
  } = props;
  const localStorageView = localStorage?.getItem('audienceIsListView');
  const localStorageViewBoolean = localStorageView === 'true';
  const [isListView, setIsListView] = useState(localStorageViewBoolean);
  const [createNewContact, setCreateNewContact] = useState(false);
  const isDashboard = (page === undefined);
  const [showEditContactAsider, setShowEditContactAsider] = useState(false);

  const showDetailProfile = useSelector((state: RootState) => state.audience.showDetailProfile);
  const articleSidebarPreviewInDetailProfile = useSelector(
    (state: RootState) => state.uiReducer.articleSidebarPreviewInDetailProfile,
  );

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return
  const openEditContactSidebar = useSelector((state: RootState) => state.globalContacts.openEditContactSidebar);
  const createContactSuccess = useSelector((state: RootState) => state.globalContacts.addNewContacts.success);
  const updateContactSuccess = useSelector((state: RootState) => state.globalContacts.updateContacts.success);
  const listCreateContactSuccess = useSelector((state: RootState) => state.audienceListDetailsReducerV2.addNewContact.success);
  const listUpdateContactSuccess = useSelector((state: RootState) => state.audienceListDetailsReducerV2.editContact.success);
  const globalAddToListMode = useSelector((state: RootState) => state.globalContacts.addToListGlobalMode);
  const addToListMode = useSelector((state: RootState) => state.audienceListDetailsReducerV2.searchTerm);
  const isOverlay = useSelector((state: RootState) => state.uiReducer.overlay);
  const { isListSelected } = useSelector((state: RootState) => state.audienceListsReducerV2);
  const { isGlobalContactsSelected, currentActiveList } = useSelector((state: RootState) => state.globalContacts);
  const scheduledEmailsList = useSelector((state: RootState) => state.audienceListDetailsReducerV2.scheduledEmailList);
  const emailScheduledModal = useSelector((state: RootState) => state.audienceListDetailsReducerV2.scheduleListModalOpen);

  // console.log('AudienceWrapper', page, tab, subTab, screen, search, pathname, history.location);

  const handleChangeView = (value: boolean) => {
    setIsListView(value);
    localStorage.setItem('audienceIsListView', JSON.stringify(value));
  };

  const showEditContactAsiderHandler = (value: boolean) => {
    setShowEditContactAsider(value);
  };

  const handleCreateNewContact = () => {
    if (scheduledEmailsList?.length && page === TAB_AUDIENCE.VIEW) {
      setScheduledEmailModalOpen(true);
      return;
    }
    setCreateNewContact(!createNewContact);
  };

  useEffect(() => {
    if (!showDetailProfile) {
      setShowEditContactAsider(false);
    }
  }, [showDetailProfile]);

  useEffect(() => {
    if ((createContactSuccess || updateContactSuccess || listCreateContactSuccess || listUpdateContactSuccess) && createNewContact) {
      setTimeout(() => {
        handleCreateNewContact();
        closeOverlay();
        resetCreateNewContactAction();
        if (listUpdateContactSuccess) dispatch({ type: LIST_CONTACTS_UPDATE_CONTACT.RESET });
      }, 3000);
    }
  }, [createContactSuccess, updateContactSuccess, listCreateContactSuccess, listUpdateContactSuccess]);

  useEffect(() => {
    if (!isOverlay && createNewContact) {
      setCreateNewContact(false);
    }
    if (!isOverlay && openEditContactSidebar) {
      closeEditContactSidePanelAction();
    }
  }, [isOverlay]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    return () => {
      closeDetailProfile();
      resetScheduledEmailLists();
      setScheduledEmailModalOpen(false);
      resetAudienceList();
      resetAudienceSearchedList();
    };
  }, []);

  return (
    <>
      <Wrapper className={classNames('audience-wrapper-new', { internalAudienceWrapper: addToListMode ? false : !isDashboard })}>
        {/* Common Header Component for Audience Pages */}
        {emailScheduledModal && (
          <DialogWrapper>
            <div className="back-overlay" />
            <ConfirmDialog
              confirm="Ok"
              onConfirm={() => setScheduledEmailModalOpen(false)}
              title="This list is attached to a scheduled AI Email. To make any changes to the list, you must unschedule the email first."
              titleQuestion="Scheduled Email(s):"
              links={scheduledEmailsList}
              // Essential CMO briefing Product Managing Marketing Analysis AI Generative Solution
            />
          </DialogWrapper>
        )}
        <Suspense fallback={<></>}>
          <AudienceStickyHeader />
        </Suspense>
        <div className="parent-container">
          <Suspense fallback={(
            <SubNavbarSearchSkeleton />
          )}
          >
            <AudienceSearchHeader
              isListView={isListView}
              setIsListView={handleChangeView}
              handleCreateNewContact={handleCreateNewContact}
              isDashboard={isDashboard}
            />
          </Suspense>
          <div className={classNames('inner-container', { internalContainer: !isDashboard }, { containerMoveUp: isGlobalContactsSelected || isListSelected || currentActiveList })}>
            {page === TAB_AUDIENCE.VIEW ? <AudienceListDetails page={page} listView={isListView} /> : ''}
            {page === TAB_AUDIENCE.LISTS ? <AudienceLists page={page} listView={isListView} /> : ''}
            {page === TAB_AUDIENCE.CONTACTS ? <AudienceContacts page={page} isGlobal listView={isListView} addToListMode={globalAddToListMode} /> : ''}
            {page === undefined ? (
              <>
                <AudienceLists page={page} listView={isListView} isDashboard />
                <AudienceContacts page={page} listView={isListView} isDashboard />
              </>
            ) : ''}
          </div>
        </div>
      </Wrapper>
      {/* <Suspense fallback={<></>}>
        <ContactsFooterWrapper toggle={false} list count={12} />
      </Suspense> */}
      <Suspense fallback={<></>}>
        <FloatingSidebarTwo isToggle={createNewContact} className="add-new-contact">
          <CreateContactSidebar
            setCloseSidebarInstantly={(value: boolean) => {
              setCreateNewContact(!value);
            }}
            listId={getQueryListId()}
          />
        </FloatingSidebarTwo>
      </Suspense>
      <Suspense fallback={<></>}>
        <FloatingSidebarTwo isToggle={openEditContactSidebar}>
          <CreateContactSidebar
            detailProfileAsider
            editSidebar
          />
        </FloatingSidebarTwo>
      </Suspense>
      <Suspense fallback={<></>}>
        <FloatingSidebarTwo
          showEditContactAsiderHandler={showEditContactAsiderHandler}
          showEditContactAsider={showEditContactAsider}
          isToggle={showDetailProfile}
          ProfileSidebar
          className="detail-person-view"
          articleSidebarPreviewInDetailProfile={articleSidebarPreviewInDetailProfile}
        >
          <DetailProfile showEditContactAsiderHandler={showEditContactAsiderHandler} />
        </FloatingSidebarTwo>
      </Suspense>
      <Suspense fallback={<></>}>
        <ExportPopupNew listId={getQueryListId()} />
      </Suspense>
    </>

  );
};

// openDetailProfile

// AudienceWrapper.defaultProps = {
//   screen: 'lisdsts',
// };

export default AudienceWrapper;
